import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, Link } from 'react-router-dom'
import classnames from 'classnames'
import { adminAddStudent, adminAddStudentimg } from '../../../redux/action/adminAction'
import AdminHomeHelper from '../../../Components/AdminHomeHelper'


const AdminAddStudent = () => {
    const store = useSelector((store) => store)
    const dispatch = useDispatch()
    const history = useHistory()
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [registrationNumber, setRegistrationNumber] = useState('')
    const [department, setDepartment] = useState('')
    const [year, setYear] = useState('')
    const [semester, setSemester] = useState('')
    const [section, setSection] = useState('')
    const [branch, setBranch] = useState('')
    const [dob, setDob] = useState('')
    const [gender, setGender] = useState('')
    const [studentMobileNumber, setContactNumber] = useState('')
    const [fatherName, setFatherName] = useState('')
    const [fatherMobileNumber, setFatherContactNumber] = useState('')
    const [aadharCard, setAadharCard] = useState('')
    const [bloodGroup, setBloodGroup] = useState('')
    const [emisNumber, setEmisNumber] = useState('')
    const [Religion, setReligion] = useState('')
    const [Community, setCommunity] = useState('')
    const [FirstGraduate, setFirstGraduate] = useState('')
    const [SpecialAdmission, setSpecialAdmission] = useState('')
    const [motherName, setMotherName] = useState('')
    const [fatherOccupation, setFatherOccupation] = useState('')
    const [MotherOccupation, setMotherOccupation] = useState('')
    const [AnnualIncome, setAnnualIncome] = useState('')
    const [BankAccountNumber, setBankAccountNumber] = useState('')
    const [IFSCcode, setIfscCode] = useState('')
    const [BankName, setBankName] = useState('')
    const [BankBranch, setBankBranch] = useState('')
    const [AcademicYear, setAcademicYear] = useState('')
    const [DateOfadmission, setDateOfAdmission] = useState('')
    const [TypeOfAdmission, setTypeOfAdmission] = useState('')
    const [CounselingNumber, setCounselingNumber] = useState('')
    const [lateralEntry, setLateralEntry] = useState('')
    const [Hosteller, setHosteller] = useState('')
    const [address, setAddress] = useState('')
    const [error, setError] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [avatar, setAvatar] = useState('')
    const imagehandler = (e) => {
        if (e.target.files && e.target.files[0]) {
            let img = e.target.files[0]
            setAvatar(img)
            console.log(img)
        }
    }

    useEffect(() => {
        if (store.error) {
            setError(store.error)
        }
    }, [store.error])
    const formHandler = (e) => {
        console.log(avatar)
        e.preventDefault()
        setIsLoading(true)
        const formData = new FormData();

        // Append the form fields to the formData object
        formData.append("name", name);
        formData.append("email", email);
        formData.append("year", year);
        formData.append("semester", semester);
        formData.append("department", department);
        formData.append("fatherName", fatherName);
        formData.append("aadharCard", aadharCard);
        formData.append("gender", gender);
        formData.append("branch", branch);
        formData.append("section", section.toUpperCase());
        formData.append("dob", dob.split("-").reverse().join("-"));
        formData.append("studentMobileNumber", studentMobileNumber);
        formData.append("fatherMobileNumber", fatherMobileNumber);
        formData.append("registrationNumber", registrationNumber);
        formData.append("bloodGroup", bloodGroup);
        formData.append("emisNumber", emisNumber);
        formData.append("Religion", Religion);
        formData.append("Community", Community);
        formData.append("FirstGraduate", FirstGraduate);
        formData.append("SpecialAdmission", SpecialAdmission);
        formData.append("motherName", motherName);
        formData.append("fatherOccupation", fatherOccupation);
        formData.append("MotherOccupation", MotherOccupation);
        formData.append("AnnualIncome", AnnualIncome);
        formData.append("BankAccountNumber", BankAccountNumber);
        formData.append("IFSCcode", IFSCcode);
        formData.append("BankName", BankName);
        formData.append("BankBranch", BankBranch);
        formData.append("AcademicYear", AcademicYear);
        formData.append("DateOfadmission", DateOfadmission);
        formData.append("TypeOfAdmission", TypeOfAdmission);
        formData.append("CounselingNumber", CounselingNumber);
        formData.append("lateralEntry", lateralEntry);
        formData.append("Hosteller", Hosteller);
        formData.append("address", address);
        formData.append("avatar", avatar);
        try {
            dispatch(adminAddStudent(formData));
        } catch (error) {
            console.error('Error:', error);
        }
    }
    useEffect(() => {
        if (store.admin.adminAddStudentFlag) {
            setError({})
        }
    }, [store.admin.adminAddStudentFlag])

    useEffect(() => {
        if (store.error || store.admin.adminAddStudentFlag) {
            setIsLoading(false)
        }
    }, [store.error, store.admin.adminAddStudentFlag])

    return (
        <div>
            <div className="container-fluid p-0">
                <div className="d-flex">
                    <div className="print-helper">
                        <AdminHomeHelper />
                    </div>
                    <div className="mx-1 w-100 ">
                        <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                            <h5><Link to='/admin/allStudents' className='text-light'><img src="/image/Back.svg" className='p-2' alt="" /></Link></h5>
                            <h3> <img src="/logo192.png" width={'50px'} alt="" /> Add Student</h3>
                            <button onClick={() => window.print()} type="button" className="print-helper btn-success btn text-light"> <img src="/image/print.svg" lt="" /> <span className=''>Download</span></button>
                        </div>
                        <form noValidate onSubmit={formHandler}>
                            <div className="row m-0">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="nameId">Student Name</label>
                                        <input onChange={(e) => setName(e.target.value)} type="text" className={classnames("form-control",
                                            {
                                                'is-invalid': error.name
                                            })} id="nameId" />
                                        {error.name && (<div className="invalid-feedback">{error.name}</div>)}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="registrationNumberId">Register Number</label>
                                        <input
                                            onChange={(e) => setRegistrationNumber(e.target.value)}
                                            type="text"
                                            className="form-control"
                                            id="registrationNumberId"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="emailId">Email</label>
                                        <input onChange={(e) => setEmail(e.target.value)} type="email" className={classnames("form-control",
                                            {
                                                'is-invalid': error.email
                                            })} id="emailId" />
                                        {error.email && (<div className="invalid-feedback">{error.email}</div>)}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="departmentId">Department</label>
                                        <select onChange={(e) => setDepartment(e.target.value)} className={classnames("form-control",
                                            {
                                                'is-invalid': error.department
                                            })} id="departmentId">
                                            <option>Select</option>
                                            <option value="ECE">ECE</option>
                                            <option value="CSE">CSE</option>
                                            <option value="AIDS">AIDS</option>
                                            <option value="EEE">EEE</option>
                                            <option value="MECH">MECH</option>
                                            <option value="CIVIL">CIVIL</option>
                                                <option value="BIO">BIO</option>
                                                <option value="AGRI">AGRI</option>
                                                <option value="MBA">MBA</option>
                                                <option value="MCA">MCA</option>
                                        </select>
                                        {error.department && (<div className="invalid-feedback">{error.department}</div>)}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="yearId">Year</label>
                                        <select onChange={(e) => setYear(e.target.value)} className={classnames("form-control",
                                            {
                                                'is-invalid': error.year
                                            })} id="yearId">
                                            <option>Select</option>
                                            <option value="I">1</option>
                                            <option value="II">2</option>
                                            <option value="III">3</option>
                                            <option value="IV">4</option>
                                        </select>
                                        {error.year && (<div className="invalid-feedback">{error.year}</div>)}
                                    </div>
                                    <div className="form-group mx-2 print-helper">
                                        <label htmlFor="semesterId">Semester</label>
                                        <select
                                            onChange={(e) => {
                                                setSemester(e.target.value);
                                            }}
                                            className={classnames('form-control', {
                                                'is-invalid': error.section,
                                            })}
                                            id="semesterId"
                                        >
                                            <option>Select</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                        </select>
                                        {error.semester && <div className="invalid-feedback">{error.semester}</div>}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="sectionId">Section</label>
                                        <input onChange={(e) => setSection(e.target.value)} type="text" className={classnames("form-control",
                                            {
                                                'is-invalid': error.section
                                            })} id="sectionId" />
                                        {error.section && (<div className="invalid-feedback">{error.section}</div>)}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="BranchId">Branch</label>
                                        <select onChange={(e) => setBranch(e.target.value)} className="form-control" id="BranchId">
                                            <option>Select</option>
                                            <option value="BE">B.E</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="dobId">DOB</label>
                                        <input onChange={(e) => setDob(e.target.value)} type="date" className={classnames("form-control",
                                            {
                                                'is-invalid': error.dob
                                            })} id="dobId" />
                                        {error.dob && (<div className="invalid-feedback">{error.dob}</div>)}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="bankAccountNumberId">Bank Account Number</label>
                                        <input onChange={(e) => setBankAccountNumber(e.target.value)} type="text" className="form-control" id="bankAccountNumberId" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="ifscCodeId">IFSC Code</label>
                                        <input onChange={(e) => setIfscCode(e.target.value)} type="text" className="form-control" id="ifscCodeId" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="bankNameId">Bank Name</label>
                                        <input onChange={(e) => setBankName(e.target.value)} type="text" className="form-control" id="bankNameId" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="bankBranchId">Bank Branch</label>
                                        <input onChange={(e) => setBankBranch(e.target.value)} type="text" className="form-control" id="bankBranchId" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="academicYearId">Academic Year</label>
                                        <select onChange={(e) => setAcademicYear(e.target.value)} className="form-control" id="academicYearId">
                                            <option>Select</option>
                                            <option value="2020-2021">2020-2021</option>
                                            <option value="2021-2022">2021-2022</option>
                                            <option value="2022-2023">2022-2023</option>
                                            <option value="2023-2024">2023-2024</option>
                                            <option value="2024-2025">2024-2025</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="dateOfAdmissionId">Date of Admission</label>
                                        <input onChange={(e) => setDateOfAdmission(e.target.value)} type="date" className="form-control" id="dateOfAdmissionId" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="typeOfAdmissionId">Type of Admission</label>
                                        <select onChange={(e) => setTypeOfAdmission(e.target.value)} className="form-control" id="typeOfAdmissionId">
                                            <option>Select</option>
                                            <option value="GOVT">GOVT</option>
                                            <option value="Management">Management</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="emisNumberId">EMIS Number</label>
                                        <input
                                            onChange={(e) => setEmisNumber(e.target.value)}
                                            type="text"
                                            className="form-control"
                                            id="emisNumberId"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="religionId">Religion</label>
                                        <select onChange={(e) => setReligion(e.target.value)} className="form-control" id="religionId">
                                            <option>Select</option>
                                            <option value="Hindu">Hindu</option>
                                            <option value="Muslim">Muslim</option>
                                            <option value="Christian">Christian</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="communityId">Community</label>
                                        <select onChange={(e) => setCommunity(e.target.value)} className="form-control" id="communityId">
                                            <option>Select</option>
                                            <option value="OC">OC</option>
                                            <option value="BC">BC</option>
                                            <option value="MBC">MBC</option>
                                            <option value="SC">SC</option>
                                            <option value="ST">ST</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">

                                    <div className="form-group">
                                        <label htmlFor="genderId">Gender</label>
                                        <select onChange={(e) => setGender(e.target.value)} className="form-control" id="genderId">
                                            <option>Select</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="numberId">Contact Number</label>
                                        <input onChange={(e) => setContactNumber(e.target.value)} required type="number" className="form-control" id="numberId" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="BgId">Blood group</label>
                                        <input onChange={(e) => setBloodGroup(e.target.value)} type="text" className="form-control" id="BgId" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="fatherId">Father Name</label>
                                        <input onChange={(e) => setFatherName(e.target.value)} type="text" className="form-control" id="fatherId" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="fatherOccupationId">Father's Occupation</label>
                                        <input
                                            onChange={(e) => setFatherOccupation(e.target.value)}
                                            type="text"
                                            className="form-control"
                                            id="fatherOccupationId"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="fathercnId">Father Contact Number</label>
                                        <input onChange={(e) => setFatherContactNumber(e.target.value)} type="number" className="form-control" id="fathercnId" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="aadharId">Aadhar Card Number</label>
                                        <input onChange={(e) => setAadharCard(e.target.value)} type="number" className="form-control" id="aadharId" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="addressId">Address</label>
                                        <input onChange={(e) => setAddress(e.target.value)} type="text" className="form-control" id="addressId" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="motherNameId">Mother's Name</label>
                                        <input onChange={(e) => setMotherName(e.target.value)} type="text" className="form-control" id="motherNameId" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="motherOccupationId">Mother's Occupation</label>
                                        <input onChange={(e) => setMotherOccupation(e.target.value)} type="text" className="form-control" id="motherOccupationId" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="annualIncomeId">Annual Income</label>
                                        <input onChange={(e) => setAnnualIncome(e.target.value)} type="text" className="form-control" id="annualIncomeId" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="counselingNumberId">Counseling Number</label>
                                        <input onChange={(e) => setCounselingNumber(e.target.value)} type="text" className="form-control" id="counselingNumberId" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="lateralEntryId">Lateral Entry</label>
                                        <select onChange={(e) => setLateralEntry(e.target.value)} className="form-control" id="lateralEntryId">
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="hostellerId">Hosteller</label>
                                        <select onChange={(e) => setHosteller(e.target.value)} className="form-control" id="hostellerId">
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="specialAdmissionId">Special Admission</label>
                                        <select
                                            onChange={(e) => setSpecialAdmission(e.target.value)}
                                            className="form-control"
                                            id="specialAdmissionId"
                                        >
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="firstGraduateId">First Graduate</label>
                                        <select
                                            onChange={(e) => setFirstGraduate(e.target.value)}
                                            className="form-control"
                                            id="firstGraduateId"
                                        >
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="inputId">Profile Picture</label>
                                        <input required className="form-control" type="file" accept=".jpg,.png,.jpeg" id="inputId" onChange={imagehandler}></input>
                                    </div>

                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-md-1">
                                    {
                                        isLoading && <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    }
                                </div>
                            </div>
                            {!isLoading && <button type="submit" className="btn btn-info m-3 "> <img src="/image/add.svg" className='mr-2 ' alt="" />Add Student</button>}
                        </form>
                    </div>
                </div>
            </div>

        </div>



    )
}

export default AdminAddStudent